import React from "react"
import loadable from '@loadable/component'
// import Helmet from "react-helmet"
import {
  GlobalStyle,
  AppWrapper,
} from "../template/containers/AppStyles/app.style"
import { useTheme } from "../context/ThemeContext"
import Layout from "../components/layout"
import SEO from "../components/seo"

import Banner from "../components/Mailroom/Banner/index"
// import MailroomMultiFeatures from "../components/Mailroom/Multi-Feature-Component/index"
import WaysToUseMailroomStatics from "../components/Mailroom/Ways-To-Use-Mailroom-Statics-Component/index"
// import FaqComponent from "../components/Mailroom/Faq-Component"
import MailroomHomeFaqs from "../data/site/MailroomHomeFaqs"

// import BronzeCtaComponent from "../components/Mailroom/Bronze-cta-component/index"
// import IndustriesComponent from "../components/Mailroom/Industries-Component/index"
// import Testonimal from "../components/Mailroom/Testimonial/index"
// import CTABanner from "../components/Competitor-Comparison/Parent-Page-Component/CTABanners/index"
// import HappyClients from "../components/Competitor-Comparison/Parent-Page-Component/Clients/index"
import { ResetCSS } from "../template/common/src/assets/css/style"
// import { caseStudyClients } from "../data/site/clients"
// import StatisticsComponent from "../components/Mailroom/Statistics-Component/index"
// import { multiFeatureMailroomIntroData } from "../data/site/competitorComparisonData"

// import { useWindowSize } from "../utils/hooks"

// const Banner = loadable(() =>
//   import("../components/Mailroom/Banner/index")
// )


// import { caseStudyClients } from "../data/site/clients"
import {
  whiteBackgroundFeature,
} from "../theme"
import {
  mailroomStaticsintroData,
} from "../data/deliveryManagementData"

// import StatisticsComponent from "../components/Mailroom/Statistics-Component/index"
import { multiFeatureMailroomIntroData, mailroomIndustriesSectionUpdateData } from "../data/site/competitorComparisonData"
// const MailroomMultiFeatures = React.lazy(() =>
//   import("../components/Mailroom/Multi-Feature-Component/index")
// )
//const StatisticsComponent = React.lazy(() =>


const MailroomMultiFeatures = loadable(() =>
  import("../components/Mailroom/Multi-Feature-Component/index")
)
const StatisticsComponent = loadable(() =>
  import("../components/Mailroom/Statistics-Component/index")
)

const BronzeCtaComponent = loadable(() =>
  import("../components/Mailroom/Bronze-cta-component/index")
)

const IndustriesComponent = loadable(() =>
  import("../components/Mailroom/Industries-Component/index")
)

const Testonimal = loadable(() =>
  import("../components/Mailroom/Testimonial/index")
)

const HappyClients = loadable(() =>
  import(
    "../components/Competitor-Comparison/Parent-Page-Component/Clients/index"
  )
)

const MailroomEfficiency = loadable(() =>
  import(
    "../components/Mailroom/MailroomEfficiency/index"
  )
)

// const CTABanner = React.lazy(() =>
const CTABanner = loadable(() =>
  import(
    "../components/Competitor-Comparison/Parent-Page-Component/CTABanners/index"
  )
)
const FaqComponent = loadable(() =>
  import("../components/Mailroom/Faq-Component")
)

const VideoModal = loadable(() =>
  import(
    "../components/Mailroom/VideoModal/index"
  )
)


// const MailroomMultiFeatures = React.lazy(() =>
//   import(
//     "../components/Mailroom/Multi-Feature-Component/index"
//   )
// )


const IndexPage = ({ location }) => {
  const theme = useTheme()
  const path = location.pathname
  const isSSR = typeof window === "undefined"
  // const size = useWindowSize()
  // var MailroomMultiFeatures;
  return (
    <Layout currentPath={path}>
      <SEO
        title="Mailroom | Mailroom Management Software For Business | PackageX"
        description="Simplify mailroom management for your business with PackageX mailroom management software. Sign up and automate your mailroom operations now."
      // keywords={[
      //   "PackageX Mailroom",
      //   "Mailroom Management Software",
      // ]}
      />
      {/* <Helmet>
        <script
          src="https://www.google.com/recaptcha/api.js"
          async
          defer
        ></script>
      </Helmet> */}

      <AppWrapper>
        <Banner
          showModal={theme.setModalIsOpen}
          setMainSelectedPlan={theme.setMainSelectedPlan}
        />
        <WaysToUseMailroomStatics
          introData={mailroomStaticsintroData}
          backgroundColor={whiteBackgroundFeature}
        />

        <MailroomMultiFeatures
          mailroomMainPage
          multiFeatureMailroomIntroData={multiFeatureMailroomIntroData}
        />
        <StatisticsComponent />
        <BronzeCtaComponent
          showModal={theme.setModalIsOpen}
          setMainSelectedPlan={theme.setMainSelectedPlan}
        />
        <IndustriesComponent mainData={mailroomIndustriesSectionUpdateData} />
        <MailroomEfficiency />
        <HappyClients noHeading />
        <Testonimal noHeadingAndDescription />
        <FaqComponent accordian={MailroomHomeFaqs} />
        <CTABanner
          showModal={theme.setModalIsOpen}
          setMainSelectedPlan={theme.setMainSelectedPlan}
        />
        <VideoModal />
        <ResetCSS />
        <GlobalStyle />

        {/* {!isSSR && (
          <React.Suspense fallback={<div />}>
            <MailroomMultiFeatures
              mailroomMainPage
              multiFeatureMailroomIntroData={multiFeatureMailroomIntroData}
            />
          </React.Suspense>
        )}
        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <StatisticsComponent />
          </React.Suspense>
        )}
        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <BronzeCtaComponent
              showModal={theme.setModalIsOpen}
              setMainSelectedPlan={theme.setMainSelectedPlan}
            />
          </React.Suspense>
        )}
        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <IndustriesComponent mainData={mailroomIndustriesSectionUpdateData} />
          </React.Suspense>
        )}
        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <MailroomEfficiency />
          </React.Suspense>
        )}
        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <HappyClients noHeading />
          </React.Suspense>
        )}
        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <Testonimal noHeadingAndDescription />
          </React.Suspense>
        )}


        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <FaqComponent accordian={MailroomHomeFaqs} />
          </React.Suspense>
        )}
        {!isSSR && (
          <React.Suspense fallback={<div />}>

            <CTABanner
              showModal={theme.setModalIsOpen}
              setMainSelectedPlan={theme.setMainSelectedPlan}
            />
          </React.Suspense>
        )}

        {!isSSR && (
          <React.Suspense fallback={<div />}>

            <VideoModal />
            <ResetCSS />
            <GlobalStyle />
          </React.Suspense>
        )} */}


      </AppWrapper>
    </Layout>
  )
}

export default IndexPage
